import { render, staticRenderFns } from "./LeaveApprovalProcess.vue?vue&type=template&id=60484ae6&scoped=true"
import script from "./LeaveApprovalProcess.vue?vue&type=script&lang=js"
export * from "./LeaveApprovalProcess.vue?vue&type=script&lang=js"
import style0 from "./LeaveApprovalProcess.vue?vue&type=style&index=0&id=60484ae6&prod&scoped=true&lang=css"
import style1 from "./LeaveApprovalProcess.vue?vue&type=style&index=1&id=60484ae6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60484ae6",
  null
  
)

export default component.exports